import React, {Suspense} from 'react';
import styles from "./index.module.scss"
import dynamic from "next/dynamic";
import {motion} from "framer-motion";

const LazyCanvasAndExperience = dynamic(() => import('./Experience/Experience'), {ssr: false});
const Illustration3DScene = () => {
    return (
        <>
            <div className={styles.illustration3DScene}/>
            <motion.div
                className={styles.illu3DCanvas}
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{duration: 0.5, delay: 1.2}}
            >
                <Suspense fallback={<span></span>}>
                    <LazyCanvasAndExperience/>
                </Suspense>
            </motion.div>
        </>
    );
};




export default Illustration3DScene;